module.exports = __webpack_public_path__ + "img/brands-figma.ea850ae2.svg";